import { useAuthStore } from './store';

/** Authenticated user — returns `null` when not logged in. */
export function useCurrentUser() {
  return useAuthStore((s) => s.user);
}

/** True when JWT is present and not expired. */
export function useIsAuthenticated(): boolean {
  return useAuthStore((s) => Boolean(s.token) && !s.isExpired());
}

/** Active tenant_id — pulled from the JWT, not user input. */
export function useTenantId(): string | null {
  return useAuthStore((s) => s.user?.tenant_id ?? null);
}

/** Permission check helper — fine-grained authorization on UI elements. */
export function usePermission(permission: string): boolean {
  return useAuthStore((s) => s.user?.permissions.includes(permission) ?? false);
}

export function useRole(role: string): boolean {
  return useAuthStore((s) => s.user?.roles.includes(role) ?? false);
}
